import { render } from "./BadgesList.vue?vue&type=template&id=1170253b"
import script from "./BadgesList.vue?vue&type=script&lang=js"
export * from "./BadgesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__